export default __webpack_public_path__ + "static/media/Seccion_promos_activaMobile_4_Septiembre.055ab5b3.webp";